import {Injectable} from '@angular/core';
import {Action, Store} from '@ngrx/store';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {AdminGroupsListService} from './admin-groups-list.service';
import * as fromRoot from '../../../../state/app.state';
import {Observable, of} from "rxjs";
import {catchError, map, mergeMap, tap} from "rxjs/operators";
import {
  FetchDashboardFilterModel
} from "../../clients-list/model/fetch-dashboard-filter.model";
import {
  FetchClinicFilterFailure,
  FetchClinicFilterRequest,
  FetchClinicFilterSuccess,
  FetchDashboardFilterFailure,
  FetchDashboardFilterRequest,
  FetchDashboardFilterSuccess,
  FetchGroupListFilterFailure,
  FetchGroupListFilterRequest,
  FetchGroupListFilterSuccess,
  FetchGroupsListFailure,
  FetchGroupsListRequest,
  FetchGroupsListSuccess,
  FetchGroupTypeFilterFailure,
  FetchGroupTypeFilterRequest,
  FetchGroupTypeFilterSuccess,
  FetchParticipantsAndCaregiversListFailure,
  FetchParticipantsAndCaregiversListRequest,
  FetchParticipantsAndCaregiversListSuccess,
  FetchParticipantsBehaviourListFailure,
  FetchParticipantsBehaviourListRequest,
  FetchParticipantsBehaviourListSuccess,
  FetchParticipantsWeightListFailure,
  FetchParticipantsWeightListRequest,
  FetchParticipantsWeightListSuccess,
  FetchStatusFilterFailure,
  FetchStatusFilterRequest,
  FetchStatusFilterSuccess,
  FetchUserStatusListFilterFailure,
  FetchUserStatusListFilterRequest,
  FetchUserStatusListFilterSuccess
} from "./admin-groups-list.actions";
import {
  FetchGroupsListModel
} from "../../clients-list/model/fetch-groups-list.model";
import {
  FetchClinicFilterModel
} from "../../clients-list/model/fetch-clinic-filter.model";
import {
  FetchStatusFilterModel
} from "../../clients-list/model/fetch-status-filter.model";
import {
  FetchGroupTypeFilterModel
} from "../../clients-list/model/fetch-group-type-filter.model";
import {
  FetchParticipantsBehaviourListModel
} from "../../clients-list/model/fetch-participants-behaviour-list.model";


@Injectable()
export class AdminGroupsListEffects {
  fetchDashboardFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchDashboardFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.adminGroupsListService.fetchDashboardFilter().pipe(
          map((response: FetchDashboardFilterModel['response']) => {
            const {data, message} = response;
            return FetchDashboardFilterSuccess({
              dashboardFilter: data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchDashboardFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchDashboardFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchDashboardFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchGroupsList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupsListRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload: FetchGroupsListModel['request']) =>
        this.adminGroupsListService.fetchGroupsList(payload).pipe(
          map((response: FetchGroupsListModel['response']) => {
            const {data, message} = response;
            return FetchGroupsListSuccess({
              groupsList: data,
              message
            });
          }),
          catchError(() => {
            return of(FetchGroupsListFailure());
          }),
          tap((action: any) => {
            if (action.type === FetchGroupsListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchGroupsListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );
  fetchClinicFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchClinicFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.adminGroupsListService.fetchClinicFilter().pipe(
          map((response: FetchClinicFilterModel['response']) => {
            const {data, message} = response;
            return FetchClinicFilterSuccess({
              clinicFilter: data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchClinicFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchClinicFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchClinicFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchStatusFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchStatusFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.adminGroupsListService.fetchStatusFilter().pipe(
          map((response: FetchStatusFilterModel['response']) => {
            const {data, message} = response;
            return FetchStatusFilterSuccess({
              statusFilter: data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchStatusFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchStatusFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchStatusFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchGroupTypeFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupTypeFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.adminGroupsListService.fetchGroupTypeFilter().pipe(
          map((response: FetchGroupTypeFilterModel['response']) => {
            const {data, message} = response;
            return FetchGroupTypeFilterSuccess({
              groupTypeFilter: data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchGroupTypeFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchGroupTypeFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchGroupTypeFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchParticipantsAndCaregiversList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchParticipantsAndCaregiversListRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.adminGroupsListService.fetchParticipantsAndCaregiversList(payload)
          .pipe(
            map((response) => {
              const {data, message} = response;
              return FetchParticipantsAndCaregiversListSuccess({
                participantsAndCaregiversList: data,
                message
              });
            }),
            catchError(() => {
              return of(FetchParticipantsAndCaregiversListFailure());
            }),
            tap((action: any) => {
              if (action.type === FetchParticipantsAndCaregiversListSuccess.type) {
                // Code to execute on API Success Action dispatch
              } else if (action.type === FetchParticipantsAndCaregiversListFailure.type) {
                // Code to execute on API Failure Action dispatch
              }
            })
          )
      )
    )
  );
  fetchGroupListFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchGroupListFilterRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.adminGroupsListService.fetchGroupListFilter(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchGroupListFilterSuccess({
              data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchGroupListFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchGroupListFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchGroupListFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchUserStatusListFilter$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchUserStatusListFilterRequest),
      map((action: any) => {
        return action;
      }),
      mergeMap(() =>
        this.adminGroupsListService.fetchUserStatusListFilter().pipe(
          map((response) => {
            const {data, message} = response;
            return FetchUserStatusListFilterSuccess({
              data,
              message
            });
          }),
          catchError((error) => {
            return of(FetchUserStatusListFilterFailure(error.message));
          }),
          tap((action: any) => {
            if (action.type === FetchUserStatusListFilterSuccess.type) {
              // Code to execute on API Success Action dispatch

            } else if (action.type === FetchUserStatusListFilterFailure.type) {
              // Code to execute on API Failure Action dispatch

            }
          })
        )
      )
    )
  );
  fetchParticipantsWeightList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchParticipantsWeightListRequest),
      map((action) => {
        return action.payload;
      }),
      mergeMap((payload) =>
        this.adminGroupsListService.fetchParticipantsWeightList(payload).pipe(
          map((response) => {
            const {data, message} = response;
            return FetchParticipantsWeightListSuccess({
              participantsWeightList: data,
              message
            });
          }),
          catchError(() => {
            return of(FetchParticipantsWeightListFailure());
          }),
          tap((action) => {
            if (action.type === FetchParticipantsWeightListSuccess.type) {
              // Code to execute on API Success Action dispatch
            } else if (action.type === FetchParticipantsWeightListFailure.type) {
              // Code to execute on API Failure Action dispatch
            }
          })
        )
      )
    )
  );
  fetchParticipantsBehaviourList$: Observable<Action> = createEffect(() =>
    this.actions.pipe(
      ofType(FetchParticipantsBehaviourListRequest),
      map((action: any) => {
        return action.payload;
      }),
      mergeMap((payload: FetchParticipantsBehaviourListModel['request']) =>
        this.adminGroupsListService.fetchParticipantsBehaviourList(payload)
          .pipe(
            map((response: FetchParticipantsBehaviourListModel['response']) => {
              const {data, message} = response;
              return FetchParticipantsBehaviourListSuccess({
                participantsBehaviourList: data,
                message
              });
            }),
            catchError(() => {
              return of(FetchParticipantsBehaviourListFailure());
            }),
            tap((action: any) => {
              if (action.type === FetchParticipantsBehaviourListSuccess.type) {
                // Code to execute on API Success Action dispatch
              } else if (action.type === FetchParticipantsBehaviourListFailure.type) {
                // Code to execute on API Failure Action dispatch
              }
            })
          )
      )
    )
  );

  constructor(
    private store: Store<fromRoot.State>,
    private adminGroupsListService: AdminGroupsListService,
    private actions: Actions,
  ) {
  }
}
